module.exports = __webpack_public_path__ + "static/img/yeswecan0028.08489d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0028.png
// module id = 594
// module chunks = 1